// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"80a13cfa","498":"ba26ff59","513":"7c1fe549"}[chunkId] + ".chunk.js";
};